import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full d-flex justify-center items-center"},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":_vm.colour,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }